<template>
  <section class="animate-pulse grid xl:grid-cols-3 md:grid-cols-2 gap-4">
    <template v-for="k in 5" :key="k">
      <JobsGridSkeletonCard />
    </template>
  </section>
</template>
